export default __webpack_public_path__ + "static/media/History.839f47f6.png";